<template>
    <div>
        <div class='justify-between items-center flex h-10 pt-0.5' v-if='!hideHeader'>
            <h5 class='text-24 lg:text-28 font-bold font-hero'>{{ company.title() }}</h5>
            <button class='text-purple-600 underline text-13 h-4' @click='() => { 
                $event.$emit("modal-open", {
                    view: "CompanyEdit",
                    editingModel: company
                })
            }'>Edit</button>
        </div>

        <div class='flex items-center mt-6 shrink-0 w-full'>
            <img :src='company.site.logos.find(a => a.tag == "[ImageFavicon]").file_name.replace("public/", "https://lp.getwork.uk/storage/")'
                class='w-10 h-10 mr-3 shrink-0' v-if='company?.site?.logos.find(a => a.tag == "[ImageFavicon]")' />

            <!-- <IconZapoAdsLogo v-else class="w-5 h-5 mr-3 shrink-0" /> -->

            <div>
                <h1 class='text-17 font-semibold link-text'>{{ company.name != null ? company.name : 'Unknown' }}</h1>
                <div class='flex items-center mt-0.5'>
                    <div class='w-2 h-2 rounded-full mr-2' :style='{ background: company.statusColour() }' />
                    <p class='text-14 leading-none mt-0.5'>{{ company.statusCustomerFriendlyName() }}</p>
                </div>
            </div>
        </div>

        <!-- <p class='text-14 text-grey-900 ml-8 mt-2'>{{ company.industry.name }}</p> -->
    </div>
</template>

<script>
    export default {
        props: {
            company: Object,
            hideHeader: { type: Boolean, default: false }
        },

        computed: {
            isCompany() {
                return this?.company?.active
            },
        },
    }
</script>